import { useTournamentRegistrationsContext } from "../contexts/TournamentRegistrations";

import {
    currencyFormat,
    defaultDateTimeFormat,
} from "../../../../../lib/utils";
import { IOrder, IOrderProduct } from "../../../../../types/api";

const useCSVHandler = () => {
    const { tournaments, masterTournaments } =
        useTournamentRegistrationsContext();

    const generateCSVRow = (o: IOrder, p: IOrderProduct) => {
        const tournamentName = p.description
            .replace(/\s*\d{1,2}[Uu]$/, "")
            .trim();
        const masterTournament = masterTournaments.find(
            t => t.name === tournamentName,
        );
        const tournament = tournaments.find(
            t => t.parent === masterTournament?.id && t.ageLevel === p.name,
        );

        return {
            orderId: o.id,
            orderDate: defaultDateTimeFormat.format(new Date(o.date)),
            status: o.status === "completed" ? "Paid" : "Unpaid",
            paidDate:
                o.completionDate &&
                defaultDateTimeFormat.format(new Date(o.completionDate)),
            tournament: `${tournamentName} - ${masterTournament?.designation}`,
            user: o.user.name,
            email: o.user.email,
            teamName: p && p.meta.teamName,
            ageLevel: p && p.name,
            fridayOk:
                p.meta.teamId &&
                tournament?.schedulingData.noFriday.includes(p.meta.teamId)
                    ? "No"
                    : "Yes",
            amount: currencyFormat.format(p.orderPrice),
            paymentType: o.paymentType,
            orderNotes: o.notes,
        };
    };

    return { generateCSVRow };
};
export default useCSVHandler;
